export const configInit = () => {
    let i = 0;
    let arr = [];
    while(i < 24){
        arr.push(false);
        i++;
    }

    return arr;
}